import React, { useMemo } from 'react'
import { FormBaseElement } from './form-base-element'
import { BaseEditorCheckbox } from '../base-editor-checkbox'
import {
  FormCheckboxInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { useUpdateFormElementProps } from './hooks/use-update-form-element-prop'
import { useManagement } from 'client/store'
import { getSettingsEditing } from 'client/reducers/managementReducer'

interface FormCheckboxProps {
  formEntity: FormInterface
  checkbox: FormCheckboxInterface
}

// NOTE: this is a draft
export const FormCheckbox = ({ formEntity, checkbox }: FormCheckboxProps) => {
  const entity = useMemo(
    () => ({
      ...checkbox,
      // TODO: add common fields props
    }),
    [checkbox],
  )

  const editingFormElementId = useManagement(getSettingsEditing).elementId

  const updateProps = useUpdateFormElementProps(formEntity, checkbox)
  return (
    <FormBaseElement
      formEntity={formEntity}
      element={checkbox}
      title={'entity_settings.checkbox.header'}
    >
      <BaseEditorCheckbox
        entity={entity}
        isEditing={editingFormElementId === checkbox.id}
        checked={false}
        onChange={() => {}}
        updateText={updateProps}
      />
    </FormBaseElement>
  )
}
